/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import { PickListsService } from '@control-tower/platform-wms';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { PickListStore } from './pick-list.store';
import {
    PickListCreate,
    PickListRead,
    PickListSearchParams,
} from '../../entities/pick-list.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class PickListDataService extends AbstractDataService<
    PickListRead,
    PickListCreate
> {
    protected EntityName = PFWmsEntities.PickList;
    constructor(
        private service: PickListsService,
        store: PickListStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(body: PickListCreate): Observable<PickListRead> {
        return this.service.pickListCreate({
            pickListViewModelCreateBody: body,
        }) as Observable<PickListRead>;
    }
    protected deleteObs$(id: string): Observable<PickListRead> {
        return this.service.pickListDelete({
            id,
        }) as Observable<PickListRead>;
    }
    protected undoDeleteObs$(id: string): Observable<PickListRead> {
        return this.service.pickListUndoDelete({
            id,
        }) as Observable<PickListRead>;
    }
    protected getObs$(id: string): Observable<PickListRead> {
        return this.service.pickListReadById({
            id,
        }) as Observable<PickListRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[]
    ): Observable<PickListRead> {
        return this.service.pickListUpdatePatch({
            id,
            operation: operations,
        }) as Observable<PickListRead>;
    }
    protected searchObs$(
        searchParams: PickListSearchParams
    ): Observable<IPagedResult<PickListRead>> {
        return this.service.pickListSearch(searchParams) as Observable<
            IPagedResult<PickListRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<IPagedResult<EntityChangeTrackingDto<PickListRead>>> {
        return this.service.pickListGetChanges(searchParams) as Observable<
            IPagedResult<EntityChangeTrackingDto<PickListRead>>
        >;
    }

    claimPicklists$(warehouseId: string, pickListIds: string[]) {
        return this.service.v1PickListsClaimPost({
            pickListClaimRequest: {
                warehouseId,
                pickListIds,
            },
        }) as Observable<PickListRead[]>;
    }

    unClaimPicklists$(warehouseId: string, pickListIds: string[]) {
        return this.service.v1PickListsUnclaimPost({
            pickListUnclaimRequest: {
                warehouseId,
                pickListIds,
                resetPicks: true,
            },
        });
    }
}
